import { Search } from "lucide-react";

export default function SearchBar({ search, onSearch }) {
  return (
    <div className="flex items-center gap-2 w-full sm:w-[320px]">
      <div className="workspace-search-control overflow-hidden w-full">
        <Search className="w-5 h-5 text-subtle flex-shrink-0" />
        <input
          type="text"
          placeholder="Rechercher un lead..."
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          className="workspace-search-input w-full outline-none bg-transparent flex-1"
        />
      </div>
    </div>
  );
}
